import { AwbCompleteStatusEnum, AwbIncompleteReason, AwbStatusEnum } from '~/graphql/__generated__/operations/ltms';

const DICTIONARIES = {
  en: {
    complete_statuses: {
      [AwbCompleteStatusEnum.Failed]: 'Failed',
      [AwbCompleteStatusEnum.FullyCompleted]: 'Fully Completed',
      [AwbCompleteStatusEnum.PartiallyCompleted]: 'Partially Completed',
    },
    incomplete_reasons: {
      [AwbIncompleteReason.AreaNotReady]: 'Area Not Ready',
      [AwbIncompleteReason.CustomerDidNotOrder]: 'Customer Did Not Order',
      [AwbIncompleteReason.DuplicateOrder]: 'Duplicate Order',
      [AwbIncompleteReason.ExternalCancel]: 'External Cancel',
      [AwbIncompleteReason.InsufficientFund]: 'Insufficient Fund',
      [AwbIncompleteReason.InsufficientTime]: 'Insufficient Time',
      [AwbIncompleteReason.InternalCancel]: 'Internal Cancel',
      [AwbIncompleteReason.ItemsDamaged]: 'Items Damaged',
      [AwbIncompleteReason.ItemsNotReady]: 'Items Not Ready',
      [AwbIncompleteReason.OutOfStock]: 'Out of Stock',
      [AwbIncompleteReason.OverloadFleet]: 'Overload Fleet',
      [AwbIncompleteReason.StoreClosed]: 'Store Closed',
      [AwbIncompleteReason.StoreNotFound]: 'Store Not Found',
      [AwbIncompleteReason.WrongPrice]: 'Wrong Price',
      [AwbIncompleteReason.WrongQuantity]: 'Wrong Quantity',
      [AwbIncompleteReason.WrongSku]: 'Wrong SKU',
    },
    on_shipment_statuses: {
      [AwbStatusEnum.ArriveAtDestination]: 'At Destination',
      [AwbStatusEnum.ArriveAtPickup]: 'At Origin',
      [AwbStatusEnum.Cancelled]: 'Cancelled',
      [AwbStatusEnum.FinishLoading]: 'Finished Loading',
      [AwbStatusEnum.FinishUnloading]: 'Finished Unloading',
      [AwbStatusEnum.OngoingToPickup]: 'Ongoing to Origin',
      [AwbStatusEnum.OnShipment]: 'Ongoing to Destination',
      [AwbStatusEnum.PodApproved]: 'POD Uploaded',
      [AwbStatusEnum.ShipmentComplete]: 'Completed',
      [AwbStatusEnum.StartLoading]: 'Start Loading',
      [AwbStatusEnum.StartUnloading]: 'Start Unloading',
      [AwbStatusEnum.Unassigned]: 'Unassigned',
      [AwbStatusEnum.Unfulfilled]: 'Unfulfilled',
    },
  },
};

export default DICTIONARIES;
